// @flow
import * as React from 'react';
import { Field } from 'redux-form';
import { DRAFT_TURN_LENGTH, league_tooltips } from '../../../../helpers';

import { FormSelect } from '../../../../components';

export const DraftSettings = () => (
	<div>

		<Field
			label='Draft Type'
			name='draft_type'
			options={[
				{
					value: 'live',
					text: 'LIVE',
				},
				{
					value: 'auto',
					text: 'AUTO',
				},
				// {
				// 	value: 'commissioner',
				// 	text: 'COMMISSIONER',
				// },
			]}
			component={FormSelect}
			tooltip={league_tooltips.draft_type}
		/>

		<Field
			label='Draft Order'
			name='draft_order'
			options={[
				{
					value: 'linear',
					text: 'LINEAR',
				},
				{
					value: 'snake',
					text: 'SNAKE',
				},
			]}
			component={FormSelect}
			tooltip={league_tooltips.draft_order}
		/>

		<Field
			label='Draft Turn Time'
			name='draft_turn'
			options={DRAFT_TURN_LENGTH}
			component={FormSelect}
			tooltip={league_tooltips.draft_turn}
		/>
	</div>
);

export default DraftSettings;


// WEBPACK FOOTER //
// ./src/pages/leagues/leaguesCreate/forms/DraftSettings.js